import type {
  DeleteSnapQuoteLineInput,
  DeleteSnapQuoteLineOutput,
} from '@snap-types/actions/delete-snap-quote-line';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [deleteSnapQuoteLine, _] = injectMutation<
  DeleteSnapQuoteLineInput,
  DeleteSnapQuoteLineOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/deleteSnapQuoteLine`,
  ({ siteCode, quoteUuid, quoteLineUuid }) => ({
    url: buildSnapQuoteUrl(siteCode, quoteUuid, `quote-lines/${quoteLineUuid}`),
    method: 'DELETE',
  }),
);

export { deleteSnapQuoteLine };
